import React from 'react';

import Badge from '../common/Badge';
import { USER_ROLES } from '../../constants/roles';

// Centralizes the role -> label/variant mapping once, reused by both
// AdminUsersPage's table and AdminUserDetailsPage - reuses the existing
// Badge component's variant system (styles/common.css) rather than
// inventing new colors. "question" uses the primary AI accent for the rarer admin role
// stand out; "neutral" is a small new variant added to admin.css using
// only existing tokens (--color-surface-hover/--color-text-muted).
function RoleBadge({ role }) {
  const isAdmin = role === USER_ROLES.ADMIN;

  return (
    <Badge variant={isAdmin ? 'question' : 'neutral'}>
      {isAdmin ? 'Admin' : 'User'}
    </Badge>
  );
}

export default RoleBadge;
